// Structural module registry only. Titles/labels are translated and live in
// the dictionary (dict.moduleNav.titles / dict.moduleNav.categories).

export type ModuleCategory = "operational" | "marketing" | "business";

export type ModuleEntry = {
  slug: string;
  category: ModuleCategory;
};

export const moduleRegistry: ModuleEntry[] = [
  { slug: "programari", category: "operational" },
  { slug: "calendar", category: "operational" },
  { slug: "pacienti", category: "operational" },
  { slug: "telemedicina", category: "operational" },
  { slug: "documente", category: "operational" },
  { slug: "formulare", category: "operational" },
  { slug: "campuri-custom", category: "operational" },
  { slug: "asistent-ai", category: "operational" },

  { slug: "website", category: "marketing" },
  { slug: "sms", category: "marketing" },
  { slug: "email-marketing", category: "marketing" },
  { slug: "pachete", category: "marketing" },
  { slug: "vouchere", category: "marketing" },
  { slug: "vanzari-online", category: "marketing" },
  { slug: "fidelizare", category: "marketing" },
  { slug: "leads", category: "marketing" },

  { slug: "rapoarte", category: "business" },
  { slug: "inventar", category: "business" },
  { slug: "pontaj", category: "business" },
  { slug: "locatii", category: "business" },
  { slug: "casa-de-marcat", category: "business" },

  { slug: "social-media", category: "marketing" },
  { slug: "abonamente", category: "marketing" },
  { slug: "api", category: "business" },
  { slug: "comisioane", category: "business" },
];

export const categoryOrder: ModuleCategory[] = ["operational", "marketing", "business"];
